import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { OnBoardComponent } from './on-board.component';
import { SetPasswordComponent } from './set-password/set-password.component';
import { ConfirmCompanyComponent } from './confirm-company/confirm-company.component';
import { SelectIndustryComponent } from './select-industry/select-industry.component';
import { CustomizeWorkspaceComponent } from './customize-workspace/customize-workspace.component';
import { LoaderComponent } from './loader/loader.component';

const routes: Routes = [
  {
    path: "",
    component: OnBoardComponent,
    children:[
      {path: "", redirectTo: "account-setup", pathMatch: "full"},
      {path: "set-password/:id", component: SetPasswordComponent, data: { animation: 'SetupPassword' }},
      {path: "company-setup", component: ConfirmCompanyComponent, data: { animation: 'Confirm' } },
      {path: "select-industry", component: SelectIndustryComponent, data: { animation: 'Industry' } },
      {path: "customize-workspace", component: CustomizeWorkspaceComponent, data: { animation: 'Workspace' } },
      {path: "loader", component: LoaderComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OnBoardRoutingModule { }
